import { Icon, getSvgIcon } from '@helpers/icons';
import * as React from 'react';
import S from './Breadcrumbs.styles';
const Breadcrumbs = (props) => {
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    , { 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        layout: props.layout === 'embedded' ? 'fullWidth' : 'default', "data-variant": props.layout ?? 'default' },
        React.createElement(S.List, { "aria-label": "breadcrumb" }, props.items.map((item, i) => (React.createElement(React.Fragment, { key: `breadcrumb-${i}` },
            i === 1 && props.items.length > 3 && (React.createElement(S.Item, { key: `breadcrumb-${i}-ellip`, "aria-hidden": true },
                "\u2026",
                getSvgIcon(Icon.Chevron))),
            React.createElement(S.Item, { key: `breadcrumb-${i}`, "data-hidden": i > 0 && !(i === props.items.length - 1 || i === props.items.length - 2) },
                React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === props.items.length - 1 ? 'location' : undefined }, item.text),
                i !== props.items.length - 1 && getSvgIcon(Icon.Chevron))))))));
};
export default Breadcrumbs;
